"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, TableHeader, TableHeaderCell, Tooltip } from "@opensea/ui-kit";
import { toLowerCase } from "@opensea/utils";
import { useIsOwnProfileAddress } from "@/components/profile/ProfileAddressProvider";
import { useHasSearchFilters } from "@/components/search/hooks";
import { useProfileItemsSortByQueryParam } from "@/hooks/query-param/use-profile-items-sort-by-query-param";
import { useSortDirectionQueryParam } from "@/hooks/query-param/use-sort-direction-query-param";
import { useTableHeader } from "@/providers/TableHeaderProvider";
import { topStickyVariants } from "@/styles/utils/sticky";
import { ItemsCount } from "../../ItemsCount";
import { ProfileItemsSelectAllCheckbox } from "../ProfileItemsSelectAllCheckbox";
import { PROFILE_ITEMS_TABLE_COLUMN_CLASSNAMES } from "./styles";
import { useProfileItemsColumnHeaders } from "./use-profile-items-columns";
export function ProfileItemsTableHeader(t0) {
  const $ = _c(26);
  const {
    className
  } = t0;
  const {
    sortBy,
    onSelectSortBy
  } = useProfileItemsSortByQueryParam();
  const {
    sortDirection,
    toggleSortDirection,
    onSelectSortDirection
  } = useSortDirectionQueryParam();
  let t1;
  if ($[0] !== onSelectSortBy || $[1] !== onSelectSortDirection || $[2] !== sortBy || $[3] !== sortDirection || $[4] !== toggleSortDirection) {
    t1 = async sort => {
      if (sort.column !== sortBy) {
        await Promise.all([onSelectSortBy(sort.column), onSelectSortDirection("DESC")]);
      } else {
        if (sort.direction !== sortDirection) {
          await toggleSortDirection();
        }
      }
    };
    $[0] = onSelectSortBy;
    $[1] = onSelectSortDirection;
    $[2] = sortBy;
    $[3] = sortDirection;
    $[4] = toggleSortDirection;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const setSelectedSort = t1;
  const isOwnProfileAddress = useIsOwnProfileAddress();
  const columns = useProfileItemsColumnHeaders();
  const {
    className: tableHeaderClassName
  } = useTableHeader();
  const hasFilters = useHasSearchFilters();
  const t2 = hasFilters ? "after-hero-header-search-pills" : "after-hero-header-toolbar";
  let t3;
  if ($[6] !== className || $[7] !== t2 || $[8] !== tableHeaderClassName) {
    t3 = classNames(topStickyVariants({
      variant: t2,
      tableHeader: true
    }), tableHeaderClassName, className);
    $[6] = className;
    $[7] = t2;
    $[8] = tableHeaderClassName;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isOwnProfileAddress) {
    t4 = isOwnProfileAddress ? <TableHeaderCell className={classNames(PROFILE_ITEMS_TABLE_COLUMN_CLASSNAMES.checkbox)}><ProfileItemsSelectAllCheckbox /></TableHeaderCell> : null;
    $[10] = isOwnProfileAddress;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TableHeaderCell className={PROFILE_ITEMS_TABLE_COLUMN_CLASSNAMES.item}><ItemsCount /></TableHeaderCell>;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== columns || $[14] !== setSelectedSort || $[15] !== sortBy || $[16] !== sortDirection) {
    let t7;
    if ($[18] !== setSelectedSort || $[19] !== sortBy || $[20] !== sortDirection) {
      t7 = column => <TableHeaderCell className={PROFILE_ITEMS_TABLE_COLUMN_CLASSNAMES[column.key]} key={column.key} sort={column.sortKey ? {
        column: column.sortKey,
        onSort: setSelectedSort,
        order: sortBy === column.sortKey ? toLowerCase(sortDirection) : undefined
      } : undefined}>{column.tooltip ? <Tooltip content={column.tooltip}><div>{column.header}</div></Tooltip> : column.header}</TableHeaderCell>;
      $[18] = setSelectedSort;
      $[19] = sortBy;
      $[20] = sortDirection;
      $[21] = t7;
    } else {
      t7 = $[21];
    }
    t6 = columns.map(t7);
    $[13] = columns;
    $[14] = setSelectedSort;
    $[15] = sortBy;
    $[16] = sortDirection;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== t6) {
    t7 = <TableHeader className={t3}>{t4}{t5}{t6}</TableHeader>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}